import React from "react";

function View(props) {
  return (
    <div className="container cid-ugMsAd49dq">
      <div className="mbr-section-head mb-5">
        <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
          <strong className="heading-border1">Connect With Us</strong>
        </h4>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-12">
          {/* <div className="col-12 col-md-12"> */}
          <div className="mbr-section-subtitle mbr-fonts-style mt-0 mb-4 display-7">
            <div className="row ">
              <div className="col-sm-12 col-md-6 col-lg-3 icon-design">
                <div className="col-12 d-flex">
                  <i className="fa fa-home" />
                  <ul className="list-unstyled">
                    <li>507, BDA Complex,</li>
                    <li>7 No. Bus Stop,</li>
                    <li>Shivaji Nagar, Bhopal</li>
                    <li>M.P. - 462016</li>
                    <li>INDIA</li>
                  </ul>
                </div>
                <div className="col-12 d-flex">
                  <i className="fa fa-clock-o" />
                  <ul className="list-unstyled">
                    <li>
                      Monday-Friday <br />
                      10:00 AM - 07:00 PM
                    </li>
                  </ul>
                </div>
              </div>

              <div className=" col-sm-12 col-md-6 col-lg-3 d-flex icon-design">
                <i className="fa fa-phone" />
                <ul className="list-unstyled">
                  <li> +91-755-4232127</li>
                  <li>+91-755-2767785</li>
                  <li>+91-7694009753</li>
                  <li>+91-7694009752</li>
                </ul>
              </div>

              <div className="col-sm-12 col-md-6 col-lg-4 d-flex icon-design">
                <i className="fa fa-envelope" />

                <ul className="list-unstyled text-justify">
                  <li> info@itscglobal.com </li>

                  <li> sales@itscglobal.com </li>

                  <li> support@itscglobal.com </li>
                </ul>
              </div>

              <div className="col-sm-12 col-lg-2 d-flex icon-design display-7">
            <i class="fa fa-link"></i>

            <ul className="list-unstyled text-justify">
              <li>
                {" "}
                <a href="" className="text-white">
                  Home
                </a>
              </li>

              <li>
                <a href="#article12-l" className="text-white">
                  About Us
                </a>
              </li>

              <li>
                {" "}
                <a href="#contact-form-3-ugMsAd4paT" className="text-white">
                  Contact
                </a>{" "}
              </li>

              <li>
                {" "}
                <a href="#faq-1-ugMsAd4ZPC" className="text-white">
                  FAQ
                </a>{" "}
              </li>
              <li>
                {" "}
                <a href="#pricing04-o" className="text-white">
                  Pricing
                </a>{" "}
              </li>
            </ul>
          </div>


            </div>
          </div>
          {/* </div> */}
        </div>

  

        <div className="col-lg-12 card-design2">
          <div className="google-map" style={{ height: "20rem" }}>
            <iframe
              // title="This is a unique title"
              // style={{ padding: "0rem" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.5481523736125!2d77.43154831455021!3d23.223131984851808!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c425b1d1def91%3A0x7ce4a1fb4a125485!2sITSC+Technologies+Pvt.+Ltd.!5e0!3m2!1sen!2sin!4v1474458825219"
            />
          </div>
        </div>

      </div>

      <hr className="line-header" />

      <div className="row">
        <div className="col-12">
          <div className="social-row">
            <div className="soc-item">
              <a
                href="https://www.facebook.com/itsctechnologies/"
                target="_blank"
              >
                <span className="mbr-iconfont socicon socicon-facebook display-7" />
              </a>
            </div>
            <div className="soc-item">
              <a
                href="https://x.com/i/flow/login?redirect_after_login=%2FITSCGroup"
                target="_blank"
              >
                <span className="mbr-iconfont socicon-twitter socicon" />
              </a>
            </div>

            <div className="soc-item">
              <a
                href="https://in.linkedin.com/company/itsc-technologies-private-limited"
                target="_blank"
              >
                <span className="mbr-iconfont socicon socicon-linkedin" />
              </a>
            </div>
          </div>
        </div>

        <div className="col-12 mt-3 footer">
          <p className="mbr-fonts-style copyright display-7">
            © 2006. All Rights Reserved. <br /> Designed & Developed by{" "}
            <a
              style={{
                color: "white",
                fontSize: "1.2rem",
                borderBottom: "1px solid white",
              }}
              href="https://itscglobal.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              ITSC Technologies (P) Ltd.
            </a>{" "}
            All Rights Reserved.
          </p>
        </div>
      </div>

      <a
        href="#"
        class="back-to-top d-flex align-items-center justify-content-center active"
      >
        <i className="fa fa-angle-double-up" style={{ fontSize: "2rem" }} />
      </a>
    </div>
  );
}

export default View;
